<template>
  <layout title="Courses">
    <div class="row">
      <div class="col-10">
        <h2>
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.index')"
          >
            Classrooms
          </inertia-link>
          /
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.edit', classroom.data.id)"
          >
            {{ classroom.data.name }}
          </inertia-link>
          /
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.sessions', classroom.data.id)"
          >
            Sessions
          </inertia-link>
          / Create
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-8">
            <form @submit.prevent="create">
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Timezone
                </label>
                <div class="col-sm-10">
                  <select class="form-control">
                    <option value="">{{ timezone }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Start at
                </label>
                <div class="col-sm-10">
                  <input
                    class="form-control datetimepicker"
                    type="text"
                    name="start_datetime"
                    id="start_datetime"
                    v-model="form.start_datetime"
                  />
                  <div
                    v-if="errors && errors.start_datetime"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.start_datetime }}
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">End at</label>
                <div class="col-sm-10">
                  <input
                    class="form-control datetimepicker"
                    type="text"
                    name="end_datetime"
                    id="end_datetime"
                    v-model="form.end_datetime"
                  />
                  <div
                    v-if="errors && errors.end_datetime"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.end_datetime }}
                  </div>
                </div>
              </div>

              <div class="form-check">
                    <label for="name" class="col-sm-2 col-form-label">
                      &nbsp;
                    </label>

                    <div class="form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="autoAcceptCB"
                      v-model="form.auto_accept"
                    />
                    <label class="form-check-label" for="autoAcceptCB">
                      Accept join requests automatically
                    </label>
                    </div>
                  </div>

              <div class="form-group row">
                <div class="col-sm-12">
                  <button type="submit" class="btn btn-primary float-right">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { onMounted } from "vue";
import AppLayout from "../../Layouts/AppLayout";
import "../../../jquery.datetimepicker.full";

export default {
  setup(props, context) {
    onMounted(() => {
      $(".datetimepicker").datetimepicker({
        minDate: 0,
        onChangeDateTime: function (dp, $input) {
          const name = $input[0].getAttribute("name");
          $input[0].dispatchEvent(new Event("input", { bubbles: true }));
        },
      });
    });
  },
  layout: AppLayout,
  props: {
    errors: Object,
    classroom: Object,
    timezone: String
  },
  data() {
    return {
      form: {
        start_datetime: "",
        end_datetime: "",
        auto_accept: false
      },
    };
  },
  methods: {
    create() {
      this.$inertia.post(
        route("classrooms.sessions.store", this.classroom.data.id),
        {
          start_datetime: this.form.start_datetime,
          end_datetime: this.form.end_datetime,
          auto_accept: this.form.auto_accept,
        }
      );
    },
  },
};
</script>
